import React from "react";
import {
  IPackageDetailsExclusion,
  IPackageDetailsInclusion,
} from "../interface/IPackageDetails.interface";

interface IProps {
  inclusions: IPackageDetailsInclusion[];
  exclusions: IPackageDetailsExclusion[];
}
const Inclusions: React.FC<IProps> = ({ inclusions, exclusions }) => {
  return (
    <>
      <div className="bg-gradient-to-r from-[#9180BA] to-transparent py-3 px-3 text-white">
        Inclusion & Exclusion
      </div>
      <div className="relative flex flex-col md:flex-row justify-center sm:justify-between gap-6 mx-4">
        <div className="w-full sm:w-1/2 p-4">
          <h3 className="typography-sub-h2-regular font-medium mb-4">
            Inclusions
          </h3>
          <ul className="list-disc list-inside typography-large-body-light text-gray-600">
            {inclusions?.map((item, index) => (
              <div
                key={index}
                className="mb-2"
                dangerouslySetInnerHTML={{
                  __html: item?.description || "",
                }}
              ></div>
            ))}
          </ul>
        </div>
        <div className="hidden sm:block absolute inset-y-0 left-1/2 w-px bg-gray-300 transform -translate-x-1/2" />

        <div className="w-full sm:w-1/2 p-4">
          <h3 className="typography-sub-h2-regular font-medium mb-4">
            Exclusions
          </h3>
          <ul className="list-disc list-inside typography-large-body-light text-gray-600">
            {exclusions?.map((item, index) => (
              <p
                key={index}
                className="mb-2"
                dangerouslySetInnerHTML={{
                  __html: item?.description || "",
                }}
              ></p>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Inclusions;
